import React, { useContext } from 'react';
import { UserContext } from 'contexts';
import CustomMenu, { CUSTOM_MENU_TYPES } from 'components/Shared/CustomMenu';
import CustomMenuItem from 'components/Shared/CustomMenuItem';
import { useSelector } from 'react-redux';

const MENU_OFFSET_TOP = 12;

const AccountSelector = ({ ...restProps }) => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const { changeAccount, changeAccountLoading } = useContext(UserContext);
  const { metadata } = useSelector((state) => state.user);
  const accountUuid = metadata.currentAccount.uuid;

  const handleAccountChange = (e) => {
    changeAccount(e.target.value);
  };

  return (
    <div {...restProps}>
      <CustomMenu
        type={CUSTOM_MENU_TYPES.SELECT}
        title={titles.accounts}
        value={!changeAccountLoading ? accountUuid : ''}
        onChange={handleAccountChange}
        reCalcDimensionsTrigger={accountUuid}
        offsetTop={MENU_OFFSET_TOP}
        disabled={changeAccountLoading}
        isLoading={changeAccountLoading}
      >
        {metadata.accounts.map((account) => (
          <CustomMenuItem key={account.uuid} value={account.uuid}>
            {account.businessName}
          </CustomMenuItem>
        ))}
      </CustomMenu>
    </div>
  );
};

export default AccountSelector;
